<template>
  <div class="TranscriptActions">

    <label v-if="room">
      <span>
        Transcript of {{room.data.name}}
      </span>
    </label>
    <div class="columns">

    <div>
      <button @click="fullscreen" title="Show in fullscreen" alt="Show in fullscreen">
        <img src="@/assets/graphics/icons/fullscreen.png" class="invert"/>
      </button>
    </div>
    <div>
      <button @click="copy" title="Copy to clipboard" alt="Copy to clipboard">
        <img src="@/assets/graphics/icons/copy.png" class="invert"/>
      </button>
    </div>
    <div>
      <button @click="print" title="Print" alt="Print">
        <img src="@/assets/graphics/icons/print.png" class="invert"/>
      </button>
    </div>
    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'TranscriptActions',
  components: {
    //Component
  },
  data: function () {
    return {
      transcript: Object
    }
  },
  props: {
  },
  computed: {
    ...mapState('socket',[
      'room'
    ]),
  },
  methods: {
    fullscreen: function (){
      //let el = this.$refs.transcript.$el
      if (this.transcript.requestFullscreen) {
        this.transcript.requestFullscreen();
      }
      else if (this.transcript.mozRequestFullScreen) { /* Firefox */
        this.transcript.mozRequestFullScreen();
      }
      else if (this.transcript.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        this.transcript.webkitRequestFullscreen();
      }
      else if (this.transcript.msRequestFullscreen) { /* IE/Edge */
        this.transcript.msRequestFullscreen();
      }
    },
    copy: function () {
      const el = document.createElement('textarea');
      el.value = this.transcript.innerText;
      el.setAttribute('readonly', '');
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
    print: function () {
      var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      mywindow.document.write('<html><head><title>Textify transcript</title></head><body >');
      //mywindow.document.write('<h1>' + document.title  + '</h1>');
      mywindow.document.write(this.transcript.innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      return true;
    }
  },
  mounted: function () {
    this.transcript = document.getElementById("transcriptContent");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.TranscriptActions{
}

.TranscriptSettings > * {
}

img{
  height: 16px;
}

img.invert {
  filter: invert(1);
}

</style>
